import { Component, Injector, OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { And, RuleInterface, StringEquals } from '@vendasta/automata';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { TriggerBaseRules } from '../../../common/decorators/trigger-rules.decorator';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { CapitalizePipe } from '../../../../../common/components/capitalize.pipe';
import { CampaignSelectorService } from '../../../../../data-services/campaign-selector.service';
import { AutomationReplacementChipsComponent } from '../../../../../common/components';
import { AutomationViewService } from '../../../../../automation/automation-view.service';
import { Observable } from 'rxjs';
import { Bounced, Clicked, Opened, Unsubscribed } from '../campaign-email.service';

const MarketingServiceProvider = 'ESP_MARKETING';

@Component({
  selector: 'automata-campaign-email-panel',
  styleUrls: ['./campaign-email-panel.component.scss'],
  templateUrl: './campaign-email-panel.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatRadioModule,
    GalaxyInputModule,
    CapitalizePipe,
    AutomationReplacementChipsComponent,
  ],
})
export class CampaignEmailPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  Opened = Opened;
  Clicked = Clicked;
  Bounced = Bounced;
  Unsubscribed = Unsubscribed;
  emailEventControl: FormControl = new FormControl(this.Opened);

  campaignIdControl: FormControl = new FormControl(null);
  campaignSelectorService = this.injector.get(CampaignSelectorService);

  isNonPartnerAutomation$: Observable<boolean> = this.automationService.isNonPartnerAutomation();

  constructor(
    protected readonly automationService: AutomationViewService,
    private readonly injector: Injector,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initFormValues();
  }

  private initFormValues(): void {
    if (this.triggerChoices?.rules?.length > 0) {
      const and = And.fromRuleInterface(this.triggerChoices.rules[0]);

      const emailEventValue = and.value[1]?.value;
      const campaignIdValue = and.value[2]?.value;

      this.emailEventControl.setValue(emailEventValue);
      this.campaignIdControl.setValue(campaignIdValue);
    } else {
      this.emailEventControl.setValue(Opened);
    }
  }

  finishedLoadingSelector(): void {
    this.savingEnabled$.next(true);
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.campaignIdControl];
  }

  isFormValid(): boolean {
    return !this.campaignIdControl.invalid;
  }

  @TriggerBaseRules
  getBaseRules(): RuleInterface[] {
    return [
      new And(
        [
          new StringEquals('{.service_provider_id}', MarketingServiceProvider),
          new StringEquals('{.event_type}', this.emailEventControl.value),
          new StringEquals('{.campaign_id}', this.campaignIdControl.value),
        ],
        '',
      ).toRuleInterface(),
    ];
  }

  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    const and = And.fromRuleInterface(rules[0]);

    and.value[1].value = this.emailEventControl.value;
    and.value[2].value = this.campaignIdControl.value;

    return [and.toRuleInterface()];
  }
}
